(ns common.schema.entities.survey.survey-template
  (:require
   [common.languages :as languages]
   [common.schema.entities.survey.survey-text-variables :as survey-text-variables]
   [common.schema.schema-utils :as su]))

(def template-language-options
  (->> languages/options
       #_(filter (fn [opt]
                   (some #{(:key opt)} [:ENG :en :EN :eng])))))

;; PO default
(def show-previous-response-default :previous-response/allow-yes)

(def show-previous-response-options
  [{:key   :previous-response/never
    :value :previous-response/never
    :label "Never show"}
   {:key   :previous-response/always
    :value :previous-response/always
    :label "Always show"}
   {:key   :previous-response/allow-yes
    :value :previous-response/allow-yes
    :label "Allow team members to choose (Default: Yes)"
    :default? true}
   {:key   :previous-response/allow-no
    :value :previous-response/allow-no
    :label "Allow team members to choose (Default: No)"}])

(def schema
  (vec
   (concat
    (su/name-unique-per-tenant :survey-template/label
                               "Label"
                               :entity.type/survey-template
                               {:authentication    su/access-user-sug
                                :system-required?  true
                                :system-semantics
                                su/user-provided-system-required-field-semantics})
    (su/url-field :survey-template/login-image "Login image url (f.e. logo)" {:authorization su/access-user-sug})
    (su/url-field :survey-template/login-banner-image "Login banner image url" {:authorization su/access-user-sug})

    (su/single-ref-field :survey-template/survey-type
                         "Survey type"
                         [:entity.type/survey-type]
                         {:default-field-visibility :in-use-disabled
                          :mandatory-config         :mandatory/always
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics})

    (su/text-edn-field :survey-template/config
                       "Configuration"
                       {:default-field-visibility :in-use-disabled
                        :authorization            su/access-user-sug})

    (su/keyword-multi-field :survey-template/languages
                            "Languages"
                            template-language-options
                            {:default-field-visibility :in-use-disabled
                             :authorization            su/access-user-sug
                             :mandatory-config         :mandatory/always
                             :system-required?         true
                             :system-semantics
                             su/user-provided-system-required-field-semantics})

    (su/text-simple-field :survey-template/info-file-url "Info file url" {:authorization su/access-user-sug})
    (su/text-simple-field :survey-template/survey-hero-image "Survey hero image url" {:authorization su/access-user-sug})

    (su/text-edn-field :survey-template/email-subject-localized
                       "Email subject localized"
                       {:authorization  su/access-user-user
                        :editor-type    :editor.type/text-mention
                        :variable-source survey-text-variables/survey-template-variable-source})
    (su/text-edn-field :survey-template/email-body-localized
                       "Email body text 1 localized"
                       {:authorization  su/access-user-user
                        :editor-type    :editor.type/richtext-mention
                        :variable-source survey-text-variables/survey-template-variable-source})
    (su/text-edn-field :survey-template/email-button-text-localized "Email button text localized" {:authorization su/access-user-user})
    (su/text-edn-field :survey-template/email-button-color-localized "Email button color" {:authorization su/access-user-user})
    (su/text-edn-field :survey-template/email-button-text-color-localized "Email button text color" {:authorization su/access-user-user})
    (su/text-edn-field :survey-template/email-body-after-button-localized
                       "Email body text 2 localized"
                       {:authorization  su/access-user-user
                        :editor-type    :editor.type/richtext-mention
                        :variable-source survey-text-variables/survey-template-variable-source})
    (su/text-edn-field :survey-template/email-hero-image-localized "Email hero image url" {:authorization su/access-user-user})

    (su/text-edn-field :survey-template/thank-you-message-localized
                       "Form submitted thank you text localized"
                       {:authorization  su/access-user-user
                        :editor-type    :editor.type/richtext-mention
                        :variable-source survey-text-variables/survey-template-variable-source})

    (su/text-simple-field :survey-template/email-subject "Email subject" {:authorization su/access-user-user
                                                                          :editor-type   :editor.type/none})
    (su/text-simple-field :survey-template/email-heading "Email heading" {:authorization su/access-user-user
                                                                          :editor-type   :editor.type/none})
    (su/text-multiline-field :survey-template/email-body "Email body" {:authorization su/access-user-user
                                                                       :editor-type   :editor.type/none})
    (su/text-simple-field :survey-template/email-button-text "Email button text" {:authorization su/access-user-user
                                                                                  :editor-type   :editor.type/none})
    (su/text-multiline-field :survey-template/email-help-text "Email help text" {:authorization su/access-user-user
                                                                                 :editor-type   :editor.type/none})
    (su/text-multiline-field :survey-template/email-footer "Email footer" {:authorization su/access-user-user
                                                                           :editor-type   :editor.type/none})
    (su/text-simple-field :survey-template/email-hero-image "Email hero image url" {:authorization su/access-user-user
                                                                                    :editor-type   :editor.type/none})
    (su/text-simple-field :survey-template/email-button-color "Email button color" {:authorization su/access-user-user
                                                                                    :editor-type   :editor.type/none})
    (su/text-simple-field :survey-template/email-help-email-address "Email help email address" {:authorization su/access-user-user
                                                                                                :editor-type   :editor.type/none})
    (su/multi-ref-field :survey-template/template-blocks "Blocks"
                        [:entity.type/survey-block]
                        {:default-field-visibility :in-use-disabled
                         :authorization            su/access-user-user})
    (su/text-edn-field :survey-template/block-order "Block order"
                       {:default-field-visibility :in-use-disabled
                        :authorization            su/access-user-user})
    (su/text-simple-field :survey-template/schema-version "Version"
                          {:default-field-visibility :in-use-disabled
                           :editor-type              :editor.type/none
                           :authorization            su/access-system-sug})
    (su/boolean-field :survey-template/show-question-external-ids?
                      "Display question external IDs?"
                      {:authorization            su/access-user-sug
                       :default-field-visibility :in-use-disabled})
    (su/url-field :survey-template/import-excel-url
                  "Import excel URL"
                  {:authorization            su/access-user-sug
                   :default-field-visibility :in-use-disabled})
    (su/keyword-field :survey-template/show-previous-response-setting
                      "Show previous response to responders"
                      show-previous-response-options
                      {:authorization            su/access-user-sug
                       :default-field-visibility :in-use-disabled}))))
